export default __webpack_public_path__ + "static/table-afaf7b89d71f1caa4b871686a3882b49.mp4";